module.exports = __webpack_public_path__ + "static/submitt-logo-68ecad022bfa2b008c7ccc7178b8b571.png";